// removed by extract-text-webpack-plugin
module.exports = {"container":"_32b6pZwIL0kX8OeKNZPbVU","nextLink":"lXSaVR_pAdrolLKD187Nz","prevLink":"_16N5YNq48lmFqgsE7RpiZ6"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/PortfolioNextPrevLink.module.scss
 ** module id = 1769
 ** module chunks = 0
 **/